import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper px-5" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-[32px] border border-line bg-cardx p-10 text-center shadow-xl">
        <div className="flex justify-center">
          <LogoMark size={44} />
        </div>
        <h1 className="mt-8 font-serif text-3xl font-semibold text-ink">
          No charge was made.
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-inksoft">
          The checkout was cancelled before payment. Whenever you're ready, the
          families are still here — and so are we.
        </p>
        <Link
          to="/"
          data-testid="btn-back-home"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-3.5 text-sm font-semibold text-[#FDFBF7] transition-colors hover:bg-branddeep"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to the campaign
        </Link>
      </div>
    </div>
  );
}
